<div>
  <h2 class="text-large text-headline">404 Page Not Found</h2>
</div>
